import { jsx } from "react/jsx-runtime";
import { useTranslation } from "../../../../lib/hooks/useTranslation.js";
import { useIsVideoPaused } from "../../../VideoContextProvider/context/state/isPaused.js";
import { useVideoController } from "../../../VideoContextProvider/context/videoController.js";
import { PauseIcon } from "./PauseIcon/index.js";
import { PlayIcon } from "./PlayIcon/index.js";
const PlayPauseButton = ({ mobile = false }) => {
  const { t } = useTranslation();
  const videoController = useVideoController();
  const isPaused = useIsVideoPaused();
  const clickFunction = isPaused ? videoController.play : videoController.pause;
  return /* @__PURE__ */jsx(
    "button",
    {
      type: "button",
      onClick: () => clickFunction(),
      className: `play-pause-button ${mobile ? "omega_playPauseMobile" : "omega_playPauseDesktop"}`,
      "aria-label": isPaused ? t("Play") : t("Pause"),
      children: isPaused ? /* @__PURE__ */jsx(PlayIcon, {}) : /* @__PURE__ */jsx(PauseIcon, {})
    }
  );
};
export {
  PlayPauseButton };
//# sourceMappingURL=dist/components/VideoContainer/VideoControlRack/PlayPauseButton/index.js.map